export const tooltip = {
  font: {
    family: 'var(--font-family-base)',
    size: 'var(--font-size-medium)',
    weight: 'var(--font-weight-base)'
  }
};
